import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import HomeTestingDashboard from './HomeTestingDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyHomeTestingDashboard } from './companyHomeTestingApi';

/** Company Home Testing → Dashboard, scoped to this company. */
const CHomeTestingDashboard = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanyHomeTestingDashboard(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Home Testing | Shoorah</title>
      </Helmet>
      <HomeTestingDashboard
        fetcher={fetcher}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
      />
    </div>
  );
};

export default CHomeTestingDashboard;
